import axios from 'axios';

async function createLead(leadData) {
  const requestBody = {
    companyName: leadData.name,
    adCategory: leadData.type,
    contact: leadData.contact,
    agreeToMarketing: leadData.isMarketingAgreed,
    x: leadData.x,
    y: leadData.y,
    ...(leadData.roadAddress && { address: leadData.roadAddress }),
    ...(leadData.type === 'STORE' && leadData.planMonths && { planMonths: leadData.planMonths }),
    ...(leadData.type === 'PRODUCT' && leadData.packagePrice && { packagePrice: leadData.packagePrice }),
    ...(leadData.type === 'PRODUCT' && { email: leadData.email }),
    ...(leadData.type === 'STORE' && { availableTime: leadData.availableTime }),
  };

  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.log('🔍 [createLead] API 요청');
  console.log('📍 URL: /marketing-lead');
  console.log('📦 Request Body:', JSON.stringify(requestBody, null, 2));
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

  const response = await axios
    .post('/marketing-lead', requestBody)
    .then(res => {
      console.log('✅ [createLead] API 응답:', res.data);
      return res.data;
    })
    .catch(err => {
      console.error('🔴 [createLead] API 에러:', err);
      throw err;
    });

  return response;
}

export { createLead };
